export default __webpack_public_path__ + "static/media/IRANSansWeb.cdb118d6.woff2";